import { DatePicker, Form, Select } from 'antd';
import { useIntl } from 'react-intl';

import { REPORT_TIME_PRESETS } from '@/pages/ugc-reports/constants';

import type { UgcReportSearchFormValues } from '@/pages/ugc-reports/utils';

const ReportTimeFilter: React.FC = () => {
    const { formatMessage } = useIntl();
    const reportTime = Form.useWatch('report_time', Form.useFormInstance<UgcReportSearchFormValues>());

    const presetOptions = REPORT_TIME_PRESETS.map((item) => ({
        label: formatMessage({ id: `ugcReports.timePreset.${item.value}` }),
        value: item.value,
    }));

    return (
        <>
            <Form.Item name="report_time" style={{ marginBottom: 0 }}>
                <Select
                    allowClear={false}
                    options={presetOptions}
                    placeholder={formatMessage({ id: 'ugcReports.search.reportTime' })}
                    style={{ width: 160 }}
                />
            </Form.Item>
            {reportTime === 'CUSTOM' ? (
                <Form.Item name="reported_at_range" style={{ marginBottom: 0 }}>
                    <DatePicker.RangePicker
                        allowClear
                        placeholder={[
                            formatMessage({ id: 'ugcReports.search.startDate' }),
                            formatMessage({ id: 'ugcReports.search.endDate' }),
                        ]}
                    />
                </Form.Item>
            ) : null}
        </>
    );
};

export default ReportTimeFilter;
